import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAppSettings } from "sr/utils/api/app-settings/appSettings";

export const fetchAppSettings = createAsyncThunk(
  "fetchAppSettings",
  async () => {
    const response = await getAppSettings();
    if (response?.success === true) {
      return response?.data;
    }
  },
);
interface AppSettingsState {
  data: any;
  reloadSetting: boolean;
  //   isAllowCleanerPaymentSettings: boolean;
  //   isAllowJobProviderPaymentSettings: boolean;
  //   isPlatformPaymentActive: boolean;
}
const initialState: AppSettingsState = {
  data: {
    isAllowCleanerPaymentSettings: false,
    isAllowJobProviderPaymentSettings: false,
    isPlatformPaymentActive: false,
    checkr_enable: false,
    cleanerCheckrEnable: false,
    companysContractorCheckrEnable: false,
  },
  reloadSetting: false,
};
const AppSettingsSlice = createSlice({
  name: "AppSettings",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(fetchAppSettings.fulfilled, (state, action) => {
      state.data = action.payload;
    });
  },
  reducers: {
    updateAppSettings: (state, action) => {
      state.data = action.payload;
    },
    updateReloadSetting: (state, action) => {
      // state.reloadSetting = action.payload;
      state.reloadSetting = !state.reloadSetting;
    },
  },
});
export const { updateAppSettings, updateReloadSetting } = AppSettingsSlice.actions;
export default AppSettingsSlice.reducer;
